import { Component, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { HelpersService } from 'src/core/services/helpers.service';
import { LandingPageService } from '../landing-page.service';

@Component({
  selector: 'app-coordinates-search',
  templateUrl: './coordinates-search.component.html',
  styleUrls: ['./coordinates-search.component.scss'],
})
export class CoordinatesSearchComponent {
  @Input() addressLabel: string;
  @Input() coordinatesType: string;
  @Input() disabled: boolean = false;
  @Output() placeSelected = new EventEmitter<any>();
  @Output() placeRemoved = new EventEmitter<any>();
  @ViewChild('searchTextField', { static: false }) searchTextField: any;

  showSearchIcon: boolean;

  get inputLabel() {
    return this.addressLabel ? this.addressLabel : '';
  }

  constructor(private helpersService: HelpersService, private landingPageService: LandingPageService) {}

  onChangeContent(event) {
    if (event && event.inputType) {
      if (event.inputType == 'insertFromPaste') {
        this.showSearchIcon = true;
      } else if (event.inputType == 'deleteContentBackward' || event.inputType == 'deleteContentForward' || event.inputType == 'deleteByCut') {
        this.showSearchIcon = true;
      } else {
        this.showSearchIcon = false;
      }
    }
  }

  convertAndCheck(): void {
    this.showSearchIcon = false;
    const place = this.searchTextField.nativeElement.value;
    if (place.match(/^([-+]?)([\d]{1,2})(((\.)(\d+)([,;])))(\s*)(([-+]?)([\d]{1,3})((\.)(\d+))?)$/g)) {
      const latlngStr = place.split(/[,;]/, 2);
      this.landingPageService.convertCoordinates(latlngStr[0].trim(), latlngStr[1].trim()).subscribe(res => {
        const latlng = [res.lat, res.lng];
        let point = { formatted_address: null, coordinates: null };
        const position = new google.maps.LatLng({
          lat: latlng[0],
          lng: latlng[1],
        });
        point['formatted_address'] = latlng[0] + ', ' + latlng[1];
        point['coordinates'] = position;
        this.placeSelected.emit({ point, isValid: true });
      });
    } else {
      this.helpersService.handleError(null, 'Insert a valid coordinates pair');
    }
  }

  check() {
    this.showSearchIcon = false;
    const place = this.searchTextField.nativeElement.value.trim();
    let point = { formatted_address: null, coordinates: null };
    if (place.match(/^([-+]?)([\d]{1,2})(((\.)(\d+)([,;])))(\s*)(([-+]?)([\d]{1,3})((\.)(\d+))?)$/g)) {
      const latlngStr = place.split(/[,;]/, 2);
      const position = new google.maps.LatLng({
        lat: parseFloat(latlngStr[0].trim()),
        lng: parseFloat(latlngStr[1].trim()),
      });
      point['formatted_address'] = place;
      point['coordinates'] = position;
      this.placeSelected.emit({ point, isValid: true });
    } else {
      this.helpersService.handleError(null, 'Insert a valid coordinates pair');
    }
  }

  checkCoordinates(): void {
    if (this.coordinatesType === 'coordinates_ed50') {
      this.convertAndCheck();
    } else {
      this.check();
    }
  }

  reset() {
    if (this.searchTextField) {
      this.searchTextField.nativeElement.value = null;
    }
    this.showSearchIcon = true;
    this.placeRemoved.emit();
  }
}
